<template>
  <div class="organization-users">
    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>Admin Users</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="adminSearch"
              clearable
              hide-details
              prepend-inner-icon="search"
              label="Search"
            ></v-text-field>
            <v-list>
              <v-list-item v-for="user in filteredAdmins" :key="user.uuid">
                <v-list-item-icon>
                  <v-icon>face</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{user.first_name}} {{user.last_name}}</v-list-item-title>
                  <v-list-item-subtitle>{{user.email}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn color="error" @click="removeUser(user.uuid)">
                    <v-icon dark left>delete</v-icon>
                    <span>Remove</span>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>Users</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="search"
              clearable
              hide-details
              prepend-inner-icon="search"
              label="Search"
            ></v-text-field>
            <v-list>
              <v-list-item v-for="user in filteredUsers" :key="user.uuid">
                <v-list-item-icon>
                  <v-icon>face</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{user.first_name}} {{user.last_name}}</v-list-item-title>
                  <v-list-item-subtitle>{{user.email}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn color="success" @click="addUser(user.uuid)">
                    <v-icon dark left>add</v-icon>
                    <span>Add</span>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="isLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    users: { type: Array, required: true },
    adminUsers: { type: Array, required: true },
    isLoading: { type: Boolean, required: true }
  },
  data() {
    return {
      search: "",
      adminSearch: ""
    };
  },
  computed: {
    filteredUsers() {
      return this.users
        .filter(
          user => !this.adminUsers.map(user => user.uuid).includes(user.uuid)
        )
        .filter(user => {
          return (
            user.first_name.includes(this.search) ||
            user.last_name.includes(this.search) ||
            user.email.match(this.search)
          );
        });
    },
    filteredAdmins() {
      return this.adminUsers.filter(user => {
        return (
          user.first_name.includes(this.adminSearch) ||
          user.last_name.includes(this.adminSearch) ||
          user.email.match(this.adminSearch)
        );
      });
    }
  },
  methods: {
    addUser(uuid) {
      this.$emit("addUser", uuid);
    },
    removeUser(uuid) {
      this.$emit("removeUser", uuid);
    }
  }
};
</script>

<style>
</style>